import type { RefundProgressStage } from "@/lib/refund-orchestrator";

export type PaymentTerminalState =
  | "checking"
  | "online"
  | "offline"
  | "unavailable";

type PaymentStatusDialogProps = {
  open: boolean;
  stage: RefundProgressStage;
  terminalState: PaymentTerminalState;
  transactionType: "payment" | "refund" | null;
};

const stageCopy: Record<
  RefundProgressStage,
  { title: string; message: string }
> = {
  preparing: {
    title: "Vorgang wird vorbereitet",
    message: "Bon und vorhandene Vorgänge werden sicher geprüft.",
  },
  booking_items: {
    title: "Pfand wird im Bon gebucht",
    message: "Lightspeed bestätigt die ausgewählten Rückgabeartikel.",
  },
  awaiting_terminal: {
    title: "Am Terminal bestätigen",
    message: "Bitte den Anweisungen auf dem Adyen-Terminal folgen.",
  },
  terminal_accepted: {
    title: "Terminalvorgang angenommen",
    message:
      "Die Terminalreferenz ist gespeichert. Lightspeed wird aktualisiert.",
  },
  finalizing_pos: {
    title: "Lightspeed wird abgeschlossen",
    message: "Finanzweg und externe Adyen-Referenz werden im Bon gespeichert.",
  },
};

const terminalCopy: Record<PaymentTerminalState, string> = {
  checking: "Terminalstatus wird geprüft",
  online: "Terminal online",
  offline: "Terminal offline",
  unavailable: "Terminalstatus nicht verfügbar",
};

export function PaymentStatusDialog({
  open,
  stage,
  terminalState,
  transactionType,
}: PaymentStatusDialogProps) {
  if (!open) return null;
  const copy = stageCopy[stage];

  return (
    <div className="modal-backdrop" role="presentation">
      <section
        aria-describedby="payment-status-message"
        aria-labelledby="payment-status-title"
        aria-modal="true"
        className="status-dialog payment-status-dialog"
        role="dialog"
      >
        <header className="dialog-header">
          <h2 id="payment-status-title">
            {transactionType === "payment"
              ? "Kartenzahlung läuft"
              : transactionType === "refund"
                ? "Rückerstattung läuft"
                : "Terminalvorgang wird ermittelt"}
          </h2>
        </header>
        <div className="status-content" aria-live="polite">
          <div className="payment-spinner" aria-hidden="true" />
          <h3>{copy.title}</h3>
          <p id="payment-status-message">{copy.message}</p>
          <div className={`payment-terminal-state ${terminalState}`}>
            <i aria-hidden="true" />
            <span>{terminalCopy[terminalState]}</span>
          </div>
          <p className="dialog-detail">
            Der Terminalaufruf wartet auf eine direkte Antwort. Die endgültige
            Adyen-Abrechnung wird anschließend im Hintergrund bestätigt.
          </p>
        </div>
      </section>
    </div>
  );
}
